import { ReactiveVar } from '@apollo/client'
import { GridApi } from 'ag-grid-community'
import IconBestFitAllColumns from 'assets/icons/context-menu/best-fit-all-columns.svg'

export const bestFitAllColumns = (gridApi: GridApi, closeMenuVar: ReactiveVar<any>) => {
  return {
    icon: IconBestFitAllColumns,
    content: 'Best Fit All Columns',
    onClick: () => {
      gridApi.sizeColumnsToFit()
      closeMenuVar(false)
    },
  }
}
